// extracted by mini-css-extract-plugin
export default {"wrapper":"TwoColsWrapper_wrapper__MUL39"};